class ProductCrossSell extends HTMLElement {
  abortController;

  connectedCallback() {
    document.addEventListener('cart:update', this.handleCartUpdate);
  }

  disconnectedCallback() {
    document.removeEventListener('cart:update', this.handleCartUpdate);
    this.abortController?.abort();
  }

  handleCartUpdate = (event) => {
    if (event.detail?.data?.didError || event.detail?.data?.source !== 'cart-items-component') return;

    this.refresh();
  };

  async refresh() {
    const sectionId = this.dataset.sectionId;
    if (!sectionId) return;

    this.abortController?.abort();

    const abortController = new AbortController();
    const url = new URL(window.location.href);
    url.searchParams.set('section_id', sectionId);
    this.abortController = abortController;

    try {
      const response = await fetch(url, { signal: abortController.signal });
      if (!response.ok) throw new Error(`Unable to refresh product cross-sell: ${response.status}`);

      const html = await response.text();
      if (abortController.signal.aborted || !this.isConnected) return;

      const parsedDocument = new DOMParser().parseFromString(html, 'text/html');
      const refreshedCrossSell = parsedDocument.getElementById(this.id);
      if (!refreshedCrossSell) throw new Error(`Product cross-sell ${this.id} was not found in the section response`);

      this.replaceChildren(...Array.from(refreshedCrossSell.childNodes));
    } catch (error) {
      if (error instanceof DOMException && error.name === 'AbortError') return;
      console.error(error);
    } finally {
      if (this.abortController === abortController) {
        this.abortController = undefined;
      }
    }
  }
}

if (!customElements.get('product-cross-sell')) {
  customElements.define('product-cross-sell', ProductCrossSell);
}
